export const USER_EMAIL_ADMIN = 'contato@alunoensina.com';
